/**
 * Reducer to handle unilateral in the send/buy flow (when, for regulatory reasons,
 * you need to provide the recipients country and name). Also it's used for the claim-money/
 * and money-claimed/ views for claiming money as someone without an account.
 *
 * TODO if it's confusing we should consider splitting this into separate reducers — or just
 * putting the unilateral stuff in send/buy since it's so light.
 */

import { ActionTypes as types } from '../constants'
import serverProps from '../utils/serverProps'

function getInitialState({
  // Used for add bank/card and open banking flows when coming back from wallet.
  recipientData: { unilateralName = '', unilateralCountryCode = '' } = {},

  isUserLoggedIn = false,
  name = unilateralName,
  timeZone = '',
  currencyCode = '',
  senderName = '',
  countryCode = unilateralCountryCode,
  isMGMTransaction = false,
  isQualifiedForMGM = false,
  email = '',
  phone = '',
  amount = '',
  loginUrl = '',
  successRedirectUrl = '',
  inferredCountryFromPhoneFailed = false,
  griffinMetadata = {},
  unilateralEntity = '',
  transactionId = '',
  resendMailStatus = false,
} = {}) {
  return {
    // used for unilateral in send flow
    name,
    countryCode,

    // Used for claim-money unilateral
    timeZone,
    isQualifiedForMGM,
    isMGMTransaction,
    senderName,
    currencyCode,
    amount,
    email,
    phone,
    loginUrl,
    successRedirectUrl,
    inferredCountryFromPhoneFailed,
    griffinMetadata,
    isUserLoggedIn,
    unilateralEntity,
    transactionId,
    resendMailStatus,
  }
}

export default (state = getInitialState(serverProps), action) => {
  switch (action.type) {
    case types.UNILATERAL.CHANGE_UNILATERAL_NAME:
      return {
        ...state,
        name: action.data.name,
      }

    case types.UNILATERAL.CHANGE_UNILATERAL_COUNTRY_CODE:
      return {
        ...state,
        countryCode: action.data.countryCode,
      }

    case types.TRANSACTION.SHOW_UNILATERAL:
      return {
        ...state,
        countryCode: action.data.userCountryCode,
      }

    case types.UNILATERAL.CLAIM_SUCCESS:
      return {
        ...state,
        isLinkingSuccess: action.data.isLinkingSuccess,
      }
    case types.UNILATERAL.CLAIM_ERROR:
      return {
        ...state,
        isLinkingFailed: action.data.isLinkingFailed,
      }

    case types.EXTERNAL.RECEIVED_EXTERNAL_PARAMS:
    case types.CROSS_BORDER.RECEIVED_RECIPIENT_DETAILS:
    case types.TRANSACTION.LEAVING_SUCCESS_PAGE:
    case types.TRANSACTION.CANCELLED_TRANSACTION:
      return getInitialState()

    case types.UNILATERAL.RESEND_MAIL_STATUS:
      return {
        ...state,
        resendMailStatus: action.data.status,
      }

    default:
      return state
  }
}
